import { inject, Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
     http = inject(HttpClient);


    // Toast Component Register
    registerToast() {}

    // Toast Success
    async Success(message: string, timer = 10000) {
        const toast = Swal.mixin({
            toast: true,
            position: 'top-right',
            showConfirmButton: false,
            timer: 10000,
            showCloseButton: true,
            width: '400px',
            background: '#4CAF50',
            color: '#fff',
            iconColor: '#fff',
            confirmButtonColor: '#4CAF50'
        });
        toast.fire({
            title: message,
            icon: 'success',
            padding: '15px 25px',
        });
    }

    // Toast Error
    async Error(message: string) {
        const toast = Swal.mixin({
            toast: true,
            position: 'top-right',
            showConfirmButton: false,
            timer: 10000,
            showCloseButton: true,
            width: '400px',
            background: '#f44336',
            color: '#fff',
            iconColor: '#fff',
            confirmButtonColor: '#f44336'
        });
        toast.fire({
            title: message,
            icon: 'error',
            padding: '15px 25px',
        });
    }

    // Toast Info
    async Info(message: string) {

        const toast = Swal.mixin({
            toast: true,
            position: 'top-right',
            showConfirmButton: false,
            timer: 10000,
            showCloseButton: true,

            width: '400px',
            background: '#2196F3',
            color: '#fff',
            iconColor: '#fff',
            confirmButtonColor: '#2196F3'
        });
        toast.fire({
            title: message,
            icon: 'info',
            padding: '15px 25px',
        });
    }
}
